import { render, staticRenderFns } from "./LearningMenu.vue?vue&type=template&id=36e5839c&scoped=true&"
import script from "./LearningMenu.vue?vue&type=script&lang=js&"
export * from "./LearningMenu.vue?vue&type=script&lang=js&"
import style0 from "./LearningMenu.vue?vue&type=style&index=0&id=36e5839c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e5839c",
  null
  
)

export default component.exports